<template>
  <div>
    <div>
      <div class="m-logbg"><img src="http://localhost:8181/survey/images/style-model/login_bg/1.jpg" style="margin-top:0px; margin-left: 0px; opacity: 1;" width="100%" ></div>
    </div>
    <div>
      <el-row style="background-color: #34495e;opacity:0.85;" >
        <el-col :span="20" :offset="2">
          <div class="dw-header-main" >
            <el-row type="flex" justify="space-between" align="middle">
              <el-col :span="4" >
                <span style="color: white;font-size:20px;">问卷系统</span>
              </el-col>
              <el-col :span="16">
                <!-- <div style="padding-left: 60px;color: white;">DWSurvey Ent 企业版 - Vue</div> -->
              </el-col>
              <el-col :span="4" style="text-align: right;" >
                <div>
                  <div style="height: 80px;line-height: 80px;">
<!--                    <el-button @click="handlePush('/login/register')">注册</el-button>-->
                    <el-button type="primary" @click="handlePush('/login')" >登录</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import DwNavMenu from '@/components/layouts/DwNavMenu.vue'

export default {
  name: 'DwHeaderLogin',
  components: {
    'dw-nav-menu': DwNavMenu
  },
  methods: {
    handlePush: function (to) {
      this.$router.push(to)
    }
  }
}
</script>

<style scoped>
.dw-header-main{
  padding: 0px;
}
.el-dropdown-link{
  color: white;
}
.m-logbg {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwHeaderLogin.vue